import { NgModule } from '@angular/core';
import { TableComponent } from './table/table.component';
import { PaginationFooterComponent } from './pagination-footer/pagination-footer.component';

/**
 * @deprecated Import and use standalone components.
 * This module will be removed shortly, since it is not needed.
 */
@NgModule({
  imports: [TableComponent, PaginationFooterComponent],
  exports: [TableComponent, PaginationFooterComponent],
})
export class SharedTableFeatureModule {}
